import { IconButton } from '@mui/material'
import React from 'react'
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import ModalBox from '../../components/modal/ModalBox';

export const DeleteIcon = ({ onClick }) => {
    return (
        <IconButton onClick={onClick}>
            <DeleteForeverIcon sx={{ color: "red", fontSize: 26 }} />
        </IconButton>
    )
}


export const DeleteModal = ({ show = false, close, name = '', action = null, title = 'Delete' }) => {
    return (
        <ModalBox
            status={show}
            onClose={() => close(false)}
            title={title}
            description={<span>Do you want to delete <strong>{name}</strong>?</span>}
            // description="Do you want to delete this community?"
            action={action}
        />
    )
}